import React from 'react';
import { Button, Form } from 'react-bootstrap';
import cn from 'classnames';

import PcCarrier from '../../../Data/PcCarrier';
import { Errors, ErrorBag } from '@inertiajs/core';
import TextInput from '../../../Components/Forms/TextInput';
import DecimalInput from '../../../Components/Forms/DecimalInput';
import { range } from '../../../utils';
import { PcCarrierAdditionalInfo } from '../PcCarriers';
import rowHasErrors from '../Helpers/RowHasErrors';

interface Props {
	currentYear: number;
	pcCarrier: Partial<PcCarrier & PcCarrierAdditionalInfo>;
	index: number;
	errors: Errors & ErrorBag;
	updateOverride: (index: number, year: string, event: React.ChangeEvent<any>) => void;
}

const PcCarrierOverridesRow = ({
	currentYear,
	pcCarrier,
	index,
	errors,
	updateOverride,
}: Props) => {
	const arrayName = 'pcCarrier';
	const errorArrayName = 'pcCarriers';
	return (
		<tr
			className={cn({
				'table-danger': rowHasErrors(errors, index),
			})}
		>
			<td
				id={`pcCarrier-${index + 1}-overrides`}
				className='row-num sticky-cell'
			>
				{index + 1}
			</td>
			<td className='align-middle'>{pcCarrier.carrier_name}</td>
			{range(currentYear - 5, currentYear).map((year: any) => (
				<td key={year}>
					<DecimalInput
						name={`overrides.${year}`}
						index={index}
						value={pcCarrier.overrides?.[year] ?? ''}
						onChange={(event, yearIndex) =>
							updateOverride(index, year, event)
						}
						errors={errors}
						arrayName={arrayName}
						errorArrayName={errorArrayName}
					/>
				</td>
			))}
		</tr>
	);
};

export default PcCarrierOverridesRow;
